import {
  GlobalRole,
  ProjectRole,
  UserStatus,
  ProjectStatus,
  Direction,
  ValidationSeverity,
  Role,
  DEFAULT_VEHICLE_LAT,
  DEFAULT_VEHICLE_LON,
  DEFAULT_VEHICLE_ALT,
  type UserProfile,
  type Project,
  type ProjectMember,
  type Route,
  type Scenario,
  type ScenarioEvent,
  type VehicleState,
  type MessageEvent,
  type ValidationResult,
} from '@k-ucap/shared';

export const mockUser: UserProfile = {
  uid: 'mock-user-001',
  email: 'demo@k-ucap.local',
  displayName: 'Demo Operator',
  globalRole: GlobalRole.OPERATOR,
  status: UserStatus.ACTIVE,
  authProvider: 'mock',
  environment: 'development',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const mockAdmin: UserProfile = {
  uid: 'mock-admin-001',
  email: 'admin@k-ucap.local',
  displayName: 'Mock Admin',
  globalRole: GlobalRole.ADMIN,
  status: UserStatus.ACTIVE,
  authProvider: 'mock',
  environment: 'development',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const mockViewer: UserProfile = {
  uid: 'mock-viewer-001',
  email: 'viewer@k-ucap.local',
  displayName: 'Mock Viewer',
  globalRole: GlobalRole.VIEWER,
  status: UserStatus.ACTIVE,
  authProvider: 'mock',
  environment: 'development',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const mockGuest: UserProfile = {
  uid: 'mock-guest-001',
  email: 'guest@k-ucap.local',
  displayName: 'Mock Guest',
  globalRole: GlobalRole.GUEST,
  status: UserStatus.ACTIVE,
  authProvider: 'mock',
  environment: 'development',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const mockProject: Project = {
  id: 'proj-demo-001',
  name: 'K-UCAP Development Project',
  description: '서해 감시비행 데모',
  status: ProjectStatus.ACTIVE,
  ownerId: mockAdmin.uid,
  environment: 'development',
  isDemo: false,
  standards: ['STANAG 4586'],
  vehicleIds: ['UAV-001', 'EAGLE-01'],
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const mockDemoProject: Project = {
  id: 'proj-demo-002',
  name: 'K-UCAP Demo Project',
  description: '고객 시연용 Demo Project',
  status: ProjectStatus.ACTIVE,
  ownerId: mockAdmin.uid,
  environment: 'development',
  isDemo: true,
  standards: ['STANAG 4586'],
  vehicleIds: ['UAV-001'],
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const mockProjectMembers: ProjectMember[] = [
  {
    id: `${mockProject.id}_${mockAdmin.uid}`,
    projectId: mockProject.id,
    uid: mockAdmin.uid,
    email: mockAdmin.email,
    displayName: mockAdmin.displayName,
    projectRole: ProjectRole.PROJECT_ADMIN,
    status: UserStatus.ACTIVE,
    joinedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: `${mockProject.id}_${mockUser.uid}`,
    projectId: mockProject.id,
    uid: mockUser.uid,
    email: mockUser.email,
    displayName: mockUser.displayName,
    projectRole: ProjectRole.OPERATOR,
    status: UserStatus.ACTIVE,
    joinedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: `${mockProject.id}_${mockViewer.uid}`,
    projectId: mockProject.id,
    uid: mockViewer.uid,
    email: mockViewer.email,
    displayName: mockViewer.displayName,
    projectRole: ProjectRole.VIEWER,
    status: UserStatus.ACTIVE,
    joinedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: `${mockDemoProject.id}_${mockGuest.uid}`,
    projectId: mockDemoProject.id,
    uid: mockGuest.uid,
    email: mockGuest.email,
    displayName: mockGuest.displayName,
    projectRole: ProjectRole.VIEWER,
    status: UserStatus.ACTIVE,
    joinedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const mockVehicles: VehicleState[] = [
  {
    id: 'UAV-001',
    projectId: mockProject.id,
    vehicleId: 'UAV-001',
    callsign: 'UAV-001',
    coordinates: {
      latitude: DEFAULT_VEHICLE_LAT,
      longitude: DEFAULT_VEHICLE_LON,
      altitudeM: DEFAULT_VEHICLE_ALT,
    },
    headingDeg: 90,
    speedMps: 35,
    status: 'CRUISE',
    environment: 'development',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'EAGLE-01',
    projectId: mockProject.id,
    vehicleId: 'EAGLE-01',
    callsign: 'EAGLE-01',
    coordinates: {
      latitude: DEFAULT_VEHICLE_LAT + 0.02,
      longitude: DEFAULT_VEHICLE_LON + 0.02,
      altitudeM: 1500,
    },
    headingDeg: 45,
    speedMps: 40,
    status: 'CRUISE',
    environment: 'development',
    updatedAt: new Date().toISOString(),
  },
];

export const mockRoute: Route = {
  id: 'route-west-sea-001',
  projectId: mockProject.id,
  name: '서해 감시비행 Route',
  description: '인천/서해권 감시비행 경로',
  waypoints: [
    { id: 'wp-1', name: '인천 기지', order: 1, coordinates: { latitude: 37.456, longitude: 126.705, altitudeM: 100 } },
    { id: 'wp-2', name: 'WP-2', order: 2, coordinates: { latitude: 37.42, longitude: 126.62, altitudeM: 300 } },
    { id: 'wp-3', name: 'WP-3', order: 3, coordinates: { latitude: 37.389, longitude: 126.647, altitudeM: 1200 } },
    { id: 'wp-4', name: 'WP-4', order: 4, coordinates: { latitude: 37.35, longitude: 126.6, altitudeM: 1200 } },
    { id: 'wp-5', name: 'WP-5', order: 5, coordinates: { latitude: 37.32, longitude: 126.55, altitudeM: 1200 } },
    { id: 'wp-6', name: '회항 지점', order: 6, coordinates: { latitude: 37.456, longitude: 126.705, altitudeM: 100 } },
  ],
  environment: 'development',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

const createEvents = (): ScenarioEvent[] => [
  { id: 'evt-1', scenarioId: 'scn-demo-001', type: 'message', messageType: 21, delayMs: 0 },
  { id: 'evt-2', scenarioId: 'scn-demo-001', type: 'message', messageType: 101, delayMs: 1000 },
  { id: 'evt-3', scenarioId: 'scn-demo-001', type: 'message', messageType: 104, delayMs: 2000 },
  { id: 'evt-4', scenarioId: 'scn-demo-001', type: 'message', messageType: 110, delayMs: 3000 },
  { id: 'evt-5', scenarioId: 'scn-demo-001', type: 'message', messageType: 1100, delayMs: 4000 },
];

export const mockScenario: Scenario = {
  id: 'scn-demo-001',
  projectId: mockProject.id,
  name: '서해 감시비행 데모',
  description: 'UAV-001/EAGLE-01 서해 감시비행 시나리오',
  status: 'idle',
  events: createEvents(),
  vehicleIds: ['UAV-001', 'EAGLE-01'],
  routeId: mockRoute.id,
  environment: 'development',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

const createPass = (_message: string): ValidationResult => ({
  severity: ValidationSeverity.PASS,
  issues: [],
  timestamp: new Date().toISOString(),
});

const createWarn = (message: string): ValidationResult => ({
  severity: ValidationSeverity.WARN,
  issues: [{ severity: ValidationSeverity.WARN, code: 'WARN-001', message, path: 'payload' }],
  timestamp: new Date().toISOString(),
});

export const mockMessages: MessageEvent[] = [
  {
    id: 'msg-001',
    projectId: mockProject.id,
    messageType: 21,
    standard: 'STANAG 4586',
    name: 'Authorisation Response',
    source: Role.VSM,
    target: Role.CUCS,
    direction: Direction.RX,
    timestamp: new Date().toISOString(),
    fields: { vehicleId: 'UAV-001', authorised: true },
    validation: createPass('Authorisation Response 수신').severity,
    environment: 'development',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'msg-002',
    projectId: mockProject.id,
    messageType: 101,
    standard: 'STANAG 4586',
    name: 'Inertial States',
    source: Role.AIR_VEHICLE,
    target: Role.CUCS,
    direction: Direction.RX,
    timestamp: new Date().toISOString(),
    fields: {
      timeStamp: Date.now(),
      vehicleId: 'UAV-001',
      cucsId: 'CUCS-01',
      latitude: DEFAULT_VEHICLE_LAT,
      longitude: DEFAULT_VEHICLE_LON,
      altitudeM: DEFAULT_VEHICLE_ALT,
      northVelocityMps: 30,
      eastVelocityMps: 10,
      verticalVelocityMps: 0,
      rollDeg: 0,
      pitchDeg: 1,
      yawDeg: 90,
    },
    validation: createPass('Inertial States 정상').severity,
    environment: 'development',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'msg-003',
    projectId: mockProject.id,
    messageType: 104,
    standard: 'STANAG 4586',
    name: 'Vehicle Operating States',
    source: Role.AIR_VEHICLE,
    target: Role.CUCS,
    direction: Direction.RX,
    timestamp: new Date().toISOString(),
    fields: { vehicleId: 'UAV-001', operatingState: 'CRUISE', fuelLevelPercent: 85 },
    validation: createPass('Operating States 정상').severity,
    environment: 'development',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'msg-004',
    projectId: mockProject.id,
    messageType: 110,
    standard: 'STANAG 4586',
    name: 'From-To-Next Waypoint States',
    source: Role.AIR_VEHICLE,
    target: Role.CUCS,
    direction: Direction.RX,
    timestamp: new Date().toISOString(),
    fields: { vehicleId: 'UAV-001', fromWaypointId: 'wp-2', toWaypointId: 'wp-3', nextWaypointId: 'wp-4' },
    validation: createPass('Waypoint States 정상').severity,
    environment: 'development',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'msg-005',
    projectId: mockProject.id,
    messageType: 1100,
    standard: 'STANAG 4586',
    name: 'Subsystem Status Alert',
    source: Role.VSM,
    target: Role.CUCS,
    direction: Direction.RX,
    timestamp: new Date().toISOString(),
    fields: { vehicleId: 'UAV-001', subsystemId: 'PAYLOAD-01', alertLevel: 'WARN', description: '페이로드 온도 상승' },
    validation: createWarn('페이로드 온도 상승 감지').severity,
    environment: 'development',
    createdAt: new Date().toISOString(),
  },
];

export const seedMockData = {
  users: [mockUser, mockAdmin, mockViewer, mockGuest],
  projects: [mockProject, mockDemoProject],
  projectMembers: mockProjectMembers,
  vehicles: mockVehicles,
  routes: [mockRoute],
  scenarios: [mockScenario],
  messageEvents: mockMessages,
};
